import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-categoria-transporte',
  templateUrl: './categoria-transporte.component.html',
  styleUrls: ['./categoria-transporte.component.css']
})
export class CategoriaTransporteRutasComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
